var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2761 24.8905C25.7554 24.3698 24.9112 24.3698 24.3905 24.8905C23.8698 25.4112 23.8698 26.2554 24.3905 26.7761L34.1144 36.5L24.3905 46.2239C23.8698 46.7446 23.8698 47.5888 24.3905 48.1095C24.9112 48.6302 25.7554 48.6302 26.2761 48.1095L36 38.3856L45.7239 48.1095C46.2446 48.6302 47.0888 48.6302 47.6095 48.1095C48.1302 47.5888 48.1302 46.7446 47.6095 46.2239L37.8856 36.5L47.6095 26.7761C48.1302 26.2554 48.1302 25.4112 47.6095 24.8905C47.0888 24.3698 46.2446 24.3698 45.7239 24.8905L36 34.6144L26.2761 24.8905Z",
    fill: "#E44949"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 70,
    height: 70,
    rx: 35,
    stroke: "#492222",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.60618d39470b5075032fd9480b9556d2.svg";
export { ForwardRef as ReactComponent };